import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ResponsiveLegalDocumentDialog from './ResponsiveLegalDocumentDialog';
import LegalSectionsBody from './LegalSectionsBody';
const PRIVACY_SECTIONS = [
    'section1',
    'section2',
    'section3',
    'section4',
    'section5',
    'section6',
    'section7',
    'section8',
    'section9',
    'section10',
    'section11',
    'section12',
    'section13'
];
const FamilyLegalPrivacyDialog = ({ open, onClose }) => {
    const { t } = useTranslation();
    const baseKey = 'familyForm.legalPrivacy';
    const contactRows = [
        {
            label: t(`${baseKey}.contact.websiteLabel`),
            value: t(`${baseKey}.contact.website`)
        },
        {
            label: t(`${baseKey}.contact.phoneLabel`),
            value: t(`${baseKey}.contact.phone`)
        },
        {
            label: t(`${baseKey}.contact.emailLabel`),
            value: t(`${baseKey}.contact.email`)
        }
    ];
    return (_jsxs(ResponsiveLegalDocumentDialog, { open: open, onClose: onClose, title: t(`${baseKey}.pageTitle`), children: [_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1 }, children: [_jsx(Typography, { variant: 'subtitle2', fontWeight: 600, color: 'text.primary', children: t(`${baseKey}.subtitle`) }), _jsx(Typography, { variant: 'body2', color: 'text.primary', sx: { lineHeight: 1.6 }, children: t(`${baseKey}.intro`) }), _jsx(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 0.5 }, children: contactRows.map(({ label, value }) => (_jsxs(Box, { sx: { display: 'flex', gap: 1, flexWrap: 'wrap' }, children: [_jsx(Typography, { variant: 'body2', fontWeight: 600, color: 'text.primary', children: label }), _jsx(Typography, { variant: 'body2', color: 'text.primary', children: value })] }, label))) }), _jsx(Typography, { variant: 'body2', color: 'text.primary', sx: { lineHeight: 1.6 }, children: t(`${baseKey}.contactNote`) })] }), _jsx(LegalSectionsBody, { translationBaseKey: baseKey, sectionKeys: PRIVACY_SECTIONS })] }));
};
export default FamilyLegalPrivacyDialog;
